import React from 'react';

import LoanStatementsRow from './LoanStatementsRow';

const LoanStatements = ({ data, loanId, selectStatement }) => {
  if (!data) {
    return null;
  }

  return (
    <div className="loanStatements">
      <div>
        <div className="loanStatementsTitle">Statements</div>
      </div>
      <div>
        {data.map((item) => (
          <LoanStatementsRow
            key={item.statementRowId}
            data={item}
            loanId={loanId}
            selectRow={() => {
              selectStatement(item.statementRowId);
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default LoanStatements;
